import React from 'react';
import './AppToast.css';

const AppToast = ({
  open,
  message,
  severity = 'success',
  onDismiss,
  style,
  dismissLabel = 'Dismiss',
}) => {
  if (!open || !message) {
    return null;
  }

  const severityClass = ['success', 'error', 'warning', 'info'].includes(severity)
    ? severity
    : 'info';

  return (
    <div
      className={`app-toast show ${severityClass}`}
      style={style}
      role="status"
      aria-live="polite"
    >
      <span className="app-toast__message">{message}</span>
      <button type="button" className="app-toast__dismiss" onClick={onDismiss}>
        {dismissLabel}
      </button>
    </div>
  );
};

export default AppToast;
